
import Vue from 'vue'
import IntroRequestForm from '@/components/IntroRequestForm.vue'
export default Vue.extend({name:'IntroPage',components:{IntroRequestForm},data:()=>({year:new Date().getFullYear()})})
